/**
 * @module ColumnContentCarousel
 * @description
 */
import React, { FC, useEffect, useState } from 'react';
import { Pagination, Navigation, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { v4 as uuidv4 } from 'uuid';
import Component from 'ui/components/Component';
import Icon from 'ui/components/Icon';
import TrackElementViewed from '~/components/helpers/TrackElementViewed';

import 'swiper/css';
import 'swiper/css/pagination';
import styles from './styles/ColumnContentCarousel.module.css';

interface Item {
  icon: string;
  heading: string;
  copy: string | JSX.Element;
}

interface Props {
  heading: string;
  subheading: string;
  items: Item[];
  position: string;
}

const ColumnContentCarousel: FC<Props> = ( { ...props } ) => {
  const {
    heading,
    subheading,
    items = [],
    position
  } = props;
  const [ instanceId, setInstanceId ] = useState();

  useEffect( () => {
    const id = uuidv4();

    setInstanceId( id );
  }, [] );

  return (
    <Component className={ styles.component }>
      <>
        <div className={ styles.header }>
          <h2 className={ styles.heading }>{ heading }</h2>
          <p className={ styles.subheading }>{ subheading }</p>
        </div>

        <div className={ styles.body }>
          <Swiper
            className={ styles.slider }
            modules={ [ Pagination, Navigation, A11y ] }
            autoHeight={ true }
            spaceBetween={ 20 }
            slidesPerView={ 1.1 }
            centeredSlides={ false }
            pagination={ {
              el: `.swiper-pagination--${ instanceId }`,
              type: 'bullets',
              clickable: true
            } }
            breakpoints={ {
              768: {
                slidesPerView: 3,
                pagination: {
                  enabled: false
                }
              },
              1280: {
                slidesPerView: 3,
                spaceBetween: 40
              }
            } }>

            { items.map( ( item, index ) => (
              <SwiperSlide key={ index } className={ styles.slide }>
                <div className={ styles.slideInfo }>
                  <Icon icon={ item.icon } className={ styles.slideIcon } />
                  <TrackElementViewed position={ `${position} - SLIDE ${index + 1}` }>
                    <h3 className={ styles.slideHeading }>{ item.heading }</h3>
                  </TrackElementViewed>
                  <p className={ styles.slideCopy }>{ item.copy }</p>
                </div>
              </SwiperSlide>
            ) ) }
          </Swiper>

          <div className={ `swiper-pagination swiper-pagination--${ instanceId } ${ styles.sliderNavigation }` } />
        </div>
      </>
    </Component>
  );
};

ColumnContentCarousel.displayName = 'ColumnContentCarousel';

export default ColumnContentCarousel;
